import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { phoneNumberVerificationErrorSelector } from '@/store/selectors/authSelector';
import { successMessageToast } from '@/utils/common/helper';

import { AuthLayout } from '@/components/auth/AuthLayout';
import { VerificationCodeForm } from '../Register';

export default function VerifyNumber() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState<any>({});

  const phoneNumberVerificationError = useSelector(
    phoneNumberVerificationErrorSelector,
  );

  useEffect(() => {
    setErrors({ phoneNumberVerificationError });
  }, [phoneNumberVerificationError]);

  useEffect(() => {
    if (success) {
      successMessageToast('Phone number verified successfully.');
      navigate('/');
    }
  }, [success]);

  return (
    <AuthLayout title={t('REGISTRATION.VERIFY_NUMBER')}>
      <VerificationCodeForm
        token={token}
        errors={errors}
        loginDisabled={success}
        setLoginDisabled={setSuccess}
      />
    </AuthLayout>
  );
}
